<template>
<div class="goods-detail-item" v-if="bundlingList && bundlingList.length ">
    <div class="blend-options" @click="bindGoBundling()">
        <a href="javascript:;">
            <div class="blend-title">
                <span class="blend-title-left" data-name="优惠套装">Discount Set</span>
                <span class="blend-title-right">
                  <!--共<em>{{bundlingList.length}}</em>款-->
                  <i></i></span>
            </div>
            <div class="blend-content">
                <ul>
                    <li class="blend-item" v-for="(item , index) in currentBundlingGoodList" >
                        <div class="goods-thumb"><img :src="item.imageSrc"></div>
                        <div class="blend-add" v-if="index != currentBundlingGoodList.length-1 "></div>
                    </li>
                </ul>
            </div>
        </a>
    </div>
</div>
</template>
<script>
    export default {
        props: {
            bundlingList: {
                type: Array,
                required: false
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {

            }
        },
        /**
         * 计算属性
         */
        computed: {
            //第一个推荐组合的商品列表
            currentBundlingGoodList: function() {
                var result = [],
                    first = [],
                    _bundlingList = this.bundlingList;
                if (_bundlingList.length) {
                    if (_bundlingList[0].goodsCommonList && _bundlingList[0].goodsCommonList.length) {
                        result = _bundlingList[0].goodsCommonList;
                        result = result.slice(0,4)
                    }
                }
                return result;
            }
        },
        /**
         * 自定义方法
         */
        methods: {
            //点击查看推荐组合
            bindGoBundling:function(){
              ga('send', 'event', '选择优惠套装按钮', '点击', '按钮点击'); //谷歌锚点

                this.$emit('gobundling')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/goods-bundling/goods-bundling.vue